import React from "react"
import PropTypes from "prop-types"
import { Card, Typography, Flex } from "antd"
import styles from "../../index.module.css"

const { Title, Text } = Typography

export const WaiverDetails = ({ title, date, location, calendarIcon, addressIcon }) => {
  return (
    <Card className={styles.detailsCard}>
      <Title level={4} className={styles.tripTitle}>
        {title}
      </Title>
      <Flex align="center" gap={12} className="mt-s"> 
        <Flex align="center">
          <img src={calendarIcon} className={styles.icon} alt="Calendar" />
          <Text className={styles.detailText}>{date}</Text>
        </Flex>
        <Flex align="center">
          <img src={addressIcon} className={styles.icon} alt="Address" />
          <Text className={styles.detailText}>{location}</Text>
        </Flex>
      </Flex>
    </Card>
  )
}

WaiverDetails.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  calendarIcon: PropTypes.string.isRequired,
  addressIcon: PropTypes.string.isRequired
}
